import { Box, Typography } from "@mui/material";
import Image from "next/image";
import * as React from "react";

export default function Head({}): React.ReactElement {
  return (
    <Box>
      <Box sx={{ height: 400, position: "relative" }}>
        <Image
          src="https://www.printy6.com/page/wp-content/uploads/2021/05/ZJEzz0C2.jpg"
          layout="fill"
          objectFit="cover"
          alt="printy6 blog"
          unoptimized={true}
        />
        <Box
          sx={{
            maxWidth: (theme) => theme.breakpoints.values.lg,
            mx: "auto",
            position: "relative",
            height: "100%",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "calc(50% - 80px)",
              px: 2,
            }}
          >
            <Typography color="white" variant="h3" component="h1">
              Printy6 Blog
            </Typography>
            <Typography color="white" variant="body1" sx={{ mt: 2 }}>
              Knowledge and inspiration for your Print on Demand business
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
